import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "../../contexts/ThemeContext";
import { CalendarCheck } from "lucide-react";
import PublicHeader from "../../components/PublicHeader/PublicHeader";
import Footer from "../../components/Footer/Footer";
import ScrollProgress from "./components/ui/ScrollProgress";
import HeroNew from "./components/sections/HeroNew";
import HowItWorks from "./components/sections/HowItWorks";
import TheProof from "./components/sections/TheProof";
import ROICalculator from "./components/sections/ROICalculator";
import CloserNew from "./components/sections/CloserNew";
import "./ResourceOptimizer.css";

const FloatingBookButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="/resource-optimizer/book"
      className={`ro-floating-book${visible ? " ro-floating-visible" : ""}`}
      aria-label="Book a free audit"
    >
      <span className="ro-floating-pulse" aria-hidden="true" />
      <span className="ro-floating-badge">FREE</span>
      <CalendarCheck size={20} strokeWidth={2.2} />
      <span className="ro-floating-label">Book your audit</span>
    </a>
  );
};

const ResourceOptimizerPage = () => {
  const { mode } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Resource Optimizer - AI Transformation | TeamGrid</title>
        <meta
          name="description"
          content="We study your organisation, map every repeatable task, and build the exact software to eliminate it. AI transformation that delivers real results."
        />
        <meta property="og:title" content="Resource Optimizer - AI Transformation | TeamGrid" />
        <meta
          property="og:description"
          content="We eliminate the work your team shouldn't be doing. Custom AI systems built for your specific operations."
        />
        <link rel="canonical" href="https://teamgrid.ai/resource-optimizer" />
      </Helmet>

      <div className={`resource-optimizer-page${mode === "light" ? " light" : ""}`}>
        <PublicHeader />
        <ScrollProgress />
        <main>
          <HeroNew />
          <HowItWorks />
          <TheProof />
          <ROICalculator />
          <CloserNew />
        </main>
        <Footer />
        <FloatingBookButton />
      </div>
    </>
  );
};

export default ResourceOptimizerPage;
